import { Injectable } from '@angular/core';
//import { User } from '../../models/AnnualRequirement/Annual-Requirement';
import { global } from '../../models/global';
import { Observable } from 'rxjs/Observable';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType } from '@angular/http';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  ROOT_URL: string;

  constructor(private http: Http) { 
    let g: global = new global();
    this.ROOT_URL = g.getApiUrl();
  }

  DSURequirementReport(userID: string, rolecode:string,year:number): Observable<any> {
    //let m_userid = { 'userId': userId };    
    let url = this.ROOT_URL + '/api/Reports/DownloadExcel';
    let body = { "userId": userID,  "roleId":rolecode,"year":year};
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
      responseType: ResponseContentType.Blob
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res;
      });
  }

  DemoSampleMISReport(userID: string,rolecode:string,year:number): Observable<any> {
    //let m_userid = { 'userId': userId };    
    let url = this.ROOT_URL + '/api/Reports/DownloadExcelMIS';
    let body = { "userId": userID,  "roleId":rolecode,"year":year};
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
      responseType: ResponseContentType.Blob
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res;
      });
  }
}
